import { Component, Input } from '@angular/core';
import { CognitiveAssessment } from '../../core-data-model/CognitiveAssessment.model';
import { SVGUtilities } from '../../core-utilities/SVG.utility';
import { Util } from '../../core-utilities/Util';

const originalWidth = 238.71;

@Component({
    selector: 'cognitive-thumbnail',
    template: `
        <div
            maskInLogRocket
            class="scalingSvgContainer"
            [ngStyle]="{
                'padding-bottom': SVG.getPaddingBottom(447.42, 105.77)
            }"
        >
            <svg
                class="scalingSvg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 477.42 105.77"
            >
                <svg:defs>
                    <svg:linearGradient
                        id="linearGradient-cognitive-assessment-thumbnail"
                        y1="102.79"
                        x2="238.71"
                        y2="102.79"
                        gradientUnits="userSpaceOnUse"
                    >
                        <svg:stop offset="0" stop-color="#c2e9ff" />
                        <svg:stop offset="1" stop-color="#0092c8" />
                    </svg:linearGradient>
                    <svg:linearGradient
                        id="linearGradient-cognitive-job-assessment-thumbnail"
                        y1="102.79"
                        x2="238.71"
                        y2="102.79"
                        gradientUnits="userSpaceOnUse"
                    >
                        <svg:stop offset="0" stop-color="#ffcca3" />
                        <svg:stop offset="1" stop-color="#ff773d" />
                    </svg:linearGradient>
                </svg:defs>
                <!--Grey Fill for Cognitive Job Assessment-->
                @if (jobCognitiveScore !== undefined) {
                    <svg:rect
                        [attr.x]="lineLocation()"
                        y="0.7"
                        [attr.width]="getShadingWidth()"
                        height="100.16"
                        style="fill:#e5e5e4"
                    />
                }
                <!--Actual Curve-->
                <svg:path
                    d="M225.68,101.44c-.94,0-1.91,0-2.87-.06-1.71-.1-3.28-.2-4.83-.42l-1-.11c-.47,0-.93-.1-1.4-.18-1.31-.22-2.86-.48-4.34-.79s-3.18-.72-4.73-1.15c-1.35-.38-2.72-.81-4.06-1.29-2.28-.8-4.55-1.73-6.77-2.76a80.61,80.61,0,0,1-7.5-4c-1.91-1.19-3.82-2.46-5.68-3.8-2.2-1.6-4.38-3.34-6.5-5.17-1.67-1.45-3.12-2.78-4.42-4-2.06-2-4.11-4.11-6.1-6.26-1.37-1.48-2.76-3-4.1-4.58-1.59-1.84-3.21-3.75-4.8-5.69l-1.45-1.78-1.71-2.1-4-5L148,50.42l-1.49-1.83c-1.83-2.28-3.73-4.53-5.65-6.65-1-1.09-2-2.17-3-3.19a46.21,46.21,0,0,0-4.72-4.22,27.28,27.28,0,0,0-6.84-4.18,17.53,17.53,0,0,0-7-1.05,20.5,20.5,0,0,0-3.78.6,23.8,23.8,0,0,0-6.1,2.62,47.16,47.16,0,0,0-3.94,2.66,43.44,43.44,0,0,0-4,3.49c-1,.91-2,2-2.89,2.87-1.31,1.4-2.67,2.85-3.94,4.33l-.56.65c-.81,1-1.62,1.87-2.42,2.83s-1.65,2-2.48,3L86.46,55.6l-1.88,2.28Q82.49,60.47,80.36,63l-2,2.3c-1.38,1.65-2.89,3.38-4.75,5.43-.66.7-1.31,1.39-1.93,2.07l-1.31,1.37c-2,2.1-3.94,4-5.62,5.53-1,1-2.09,1.89-3.14,2.81C59.86,84,58,85.55,56.11,87s-3.83,2.73-5.81,4A72.58,72.58,0,0,1,41,95.86a67,67,0,0,1-9.19,3.22,66.52,66.52,0,0,1-9.52,1.86,69.28,69.28,0,0,1-8.18.51h-.49v-1.1h.51a69.26,69.26,0,0,0,8.14-.51A65.67,65.67,0,0,0,31.79,98a66.61,66.61,0,0,0,9.12-3.26,72.42,72.42,0,0,0,9.19-4.88c2-1.27,3.94-2.62,5.79-4S59.61,83,61.42,81.4c1.05-.91,2.1-1.83,3.13-2.8,1.67-1.55,3.65-3.42,5.59-5.5l1.31-1.37c.66-.68,1.31-1.36,1.92-2.06,1.85-2,3.35-3.77,4.73-5.41l2-2.3q2.12-2.52,4.21-5.1l1.88-2.29,2.63-3.22c.83-1,1.65-2,2.49-3s1.61-1.89,2.43-2.84l.57-.65c1.31-1.49,2.63-2.93,4-4.36.93-1,1.92-2,2.91-2.93A51,51,0,0,1,105.24,34a37.32,37.32,0,0,1,3.94-2.69,24.22,24.22,0,0,1,6.2-2.65,20.77,20.77,0,0,1,3.85-.61,16.9,16.9,0,0,1,2.95.08,16.7,16.7,0,0,1,4.23,1.07,27.53,27.53,0,0,1,6.95,4.18,47.07,47.07,0,0,1,4.77,4.27c1,1,2,2.12,3,3.21,1.93,2.14,3.84,4.38,5.68,6.69l1.48,1.82,1.52,1.86,4,5.08,1.7,2.09,1.45,1.78c1.59,2,3.2,3.84,4.79,5.67,1.31,1.55,2.72,3.08,4.09,4.56,2,2.14,4,4.24,6.08,6.24,1.31,1.25,2.74,2.57,4.4,4,2.1,1.82,4.27,3.55,6.46,5.14,1.85,1.33,3.75,2.6,5.65,3.78a80,80,0,0,0,7.45,4c2.2,1,4.48,2,6.74,2.75,1.31.48,2.7.91,4,1.28,1.55.43,3.13.81,4.71,1.15s3,.57,4.32.78c.46.08.92.13,1.37.18l1,.11c1.57.23,3.1.32,4.8.42,1,.06,1.9.06,2.85.06Z"
                    style="fill:#7c7c7c"
                />
                <!--Compassing Box for thumbnail-->
                <svg:path
                    d="M237.71,1V99.85H1V1H237.71m1-1H0V100.85H238.71V0Z"
                    style="fill:#c9cbcc"
                />
                <!--Gradient Rectangle-->
                @if (jobCognitiveScore !== undefined) {
                    <svg:rect
                        y="99.79"
                        width="238.71"
                        height="6"
                        [attr.fill]="
                            SVG.getGradientUrl(
                                'linearGradient-cognitive-job-assessment-thumbnail'
                            )
                        "
                    />
                }
                @if (personCognitiveScore !== undefined) {
                    <svg:rect
                        y="99.79"
                        width="238.71"
                        height="6"
                        [attr.fill]="
                            SVG.getGradientUrl(
                                'linearGradient-cognitive-assessment-thumbnail'
                            )
                        "
                    />
                }
                <!--Score Marker Line-->
                <svg:line
                    [attr.x1]="lineLocation()"
                    y1="14.47"
                    [attr.x2]="lineLocation()"
                    y2="100.04"
                    style="stroke: black; stroke-miterlimit: 10;"
                />
                <svg:circle
                    [attr.cx]="lineLocation()"
                    cy="13.87"
                    r="6.49"
                    [attr.fill]="setColor()"
                />
            </svg>
        </div>
    `,
    standalone: false
})
export class CognitiveAssessmentImageThumbnailComponent {
    @Input()
    jobCognitiveScore: number;
    @Input()
    personCognitiveScore: number;
    @Input()
    width: number = originalWidth;

    height: number;
    curveStartXPoint = 23; // Starting X point of the curve
    curveBaseLength = 193; // Total lenght over which the curve spreads
    totalBaseLength = 238.71; // Total width of graph i.e gradient
    cognitiveRangeTotal = 350; // Absolute difference between 450 and 100

    personColor = '#0092c8'; // blue
    jobColor = '#ff773d'; // orange

    SVG: SVGUtilities;

    constructor(util: Util) {
        this.SVG = util.svg;
    }

    lineLocation() {
        if (!this.jobCognitiveScore && !this.personCognitiveScore) {
            throw Error(
                'Incorrect use of component: Component expects either PersonCognitiveScore or JobCognitiveScore'
            );
        }
        const score = this.personCognitiveScore
            ? this.personCognitiveScore
            : this.jobCognitiveScore;
        const percentile = CognitiveAssessment.getPercentileFromScore(score);
        return (
            (percentile / 100) * this.curveBaseLength + this.curveStartXPoint
        );
    }

    getShadingWidth() {
        return this.totalBaseLength - this.lineLocation();
    }

    setColor() {
        return this.personCognitiveScore ? this.personColor : this.jobColor;
    }
}
